import {postMethod, deleteMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/ai/files', request)
}

async function remove(request) {
    return await deleteMethod('/proxy/ai/files', request)
}

export {post, remove}
